/** Login session. Lives in the NgRx store; mirrored to this tab's sessionStorage (see auth-session.ts). */
export interface AuthState {
  token: string | null;
  user: any | null;
  selectedAgency: any | null;
}

export const initialAuthState: AuthState = {
  token: null,
  user: null,
  selectedAgency: null,
};
